/* Souvence — Funnel Full Page 1.
   Cinq ecrans, une seule page, zero rechargement jusqu'a l'editeur Printbox.
   Depend de sv-funnel-search.js (window.SVSearch). */
(function () {
  'use strict';

  var root = document.querySelector('[data-sv-funnel]');
  if (!root || !window.SVSearch) return;

  var LEAVE_MS = 200;     // aligne sur la transition CSS de .page
  var CONFIRM_MS = 380;   // on laisse voir la coche avant de partir
  // Revision d'API Klaviyo. 2024-10-15 partait a la retraite le 2026-10-15 ;
  // 2026-07-15 est la revision courante, sans date de retrait annoncee.
  var KLAVIYO_REVISION = '2026-07-15';
  /* Categories ou l'on propose en plus le gabarit generique en derniere carte.
     Le voyage l'a de toute facon via son titre de destination. */
  var FALLBACK_CATEGORIES = { trip: 1, family: 1 };
  var MAX_COVERS = 3;     // au dela, on passe en grille 5 colonnes (3 sur mobile)

  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var COPY = {};
  try { COPY = JSON.parse(root.querySelector('[data-sv-copy]').textContent); } catch (e) {}

  /* ------------------------------------------------------------- traqueur
     Chaque decision du parcours part vers /api/tracking/event (table
     `tracking_events` de souvence-finance), via `window.scTrack` pose par
     snippets/sc-track.liquid. Deux champs rendent le chemin reconstituable :
       parcours  identifiant de la visite, garde jusqu'a la PDP et l'editeur
       etape     numero d'ordre, 1, 2, 3... dans l'ordre reel des clics
     Sans ces deux champs on ne saurait compter que des totaux, pas des
     chemins. */
  var PARCOURS_CLE = 'sv_funnel_run';

  /* Un identifiant NEUF a chaque chargement de la page du funnel : un parcours
     = une tentative. Si on le reprenait dans sessionStorage, deux essais dans
     le meme onglet se melangeraient en un seul chemin. Il est stocke pour que
     la page produit et l'editeur, eux, le RELISENT sans le regenerer. */
  var PARCOURS = 'r' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  try { sessionStorage.setItem(PARCOURS_CLE, PARCOURS); } catch (e) {}

  function parcoursId() { return PARCOURS; }

  var etape = 0;

  function track(nom, props) {
    etape += 1;
    var base = {
      parcours: parcoursId(),
      etape: etape,
      langue: root.dataset.lang || null,
      pays: root.dataset.country || null,
      support: window.matchMedia('(min-width: 700px)').matches ? 'desktop' : 'mobile',
      categorie: state.category,
      occasion: state.occasion
    };
    if (props) Object.keys(props).forEach(function (k) { base[k] = props[k]; });
    try {
      if (typeof window.scTrack === 'function') window.scTrack(nom, base);
      else console.warn('[sv-funnel] scTrack absent, evenement perdu :', nom);
    } catch (e) { console.warn('[sv-funnel] track KO', e); }
  }

  var state = { category: null, occasion: null, destination: '',
                template: null, skipped: false, matchHow: null };
  var search = null;
  var history_ = [];

  /* ------------------------------------------------------------------ utils */

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function screenEl(name) { return $('[data-screen="' + name + '"]'); }

  function show(name, push, instant) {
    var current = $('.sv-screen.is-active');
    var next = screenEl(name);
    if (!next || current === next) return;
    if (push !== false && current) history_.push(current.dataset.screen);

    function swap() {
      if (current) { current.classList.remove('is-active', 'is-leaving'); }
      next.classList.add('is-active');
      // On change d'ecran : on revient en haut. Sans ca, apres avoir descendu
      // la grille des couvertures, l'ecran suivant s'affichait deja defile.
      window.scrollTo(0, 0);
      var back = $('[data-sv-back]');
      if (back) back.hidden = history_.length === 0;
      var focusable = next.querySelector('input');
      if (focusable && name !== 'category') {
        // pas de focus auto sur mobile : ca ouvre le clavier et casse le 100vh
        if (window.matchMedia('(min-width: 700px)').matches) focusable.focus();
      }
    }

    if (current && !reduced && !instant) {
      current.classList.add('is-leaving');
      setTimeout(swap, LEAVE_MS);
    } else { swap(); }
  }

  function goBack() {
    var prev = history_.pop();
    if (!prev) return;
    track('funnel_retour', { depuis: $('.sv-screen.is-active').dataset.screen, vers: prev });
    show(prev, false);
  }

  function press(nodes, active) {
    nodes.forEach(function (n) { n.setAttribute('aria-pressed', String(n === active)); });
  }

  function setError(form, message) {
    var box = form.parentElement.querySelector('.field-error');
    if (!box) return;
    box.textContent = message || '';
    box.classList.toggle('is-visible', !!message);
  }

  /* ------------------------------------------------------- chargement index */

  var ready = Promise.all([
    fetch(root.dataset.indexUrl).then(function (r) { return r.json(); }),
    fetch(root.dataset.aliasUrl).then(function (r) { return r.json(); })
  ]).then(function (res) {
    search = new window.SVSearch.Search(res[0], res[1], root.dataset.lang);
    return search;
  }).catch(function (err) {
    // Sans index on ne peut rien proposer : on renvoie vers la collection.
    console.error('[sv-funnel] index indisponible', err);
    return null;
  });

  /* Le gabarit de repli, propose en derniere carte : « Classic Memories »,
     le gabarit generique (fond beige + photo centree). « Blank » reste en
     secours si jamais la variante disparaissait du catalogue. */
  function blankTemplate() {
    if (!search) return null;
    var all = search.index;
    var i;
    for (i = 0; i < all.length; i++) if (all[i].t === COPY.fallbackTitle) return all[i];
    for (i = 0; i < all.length; i++) if (all[i].t === COPY.blankTitle) return all[i];
    return null;
  }

  /* ------------------------------------------------------- rendu couvertures */

  function checkMark() {
    var mark = document.createElement('span');
    mark.className = 'cover__mark';
    mark.setAttribute('aria-hidden', 'true');
    mark.innerHTML = '<svg viewBox="0 0 24 24"><path d="M9.6 16.2L5.4 12l-1.4 1.4 5.6 5.6L20.4 8.2 19 6.8z"/></svg>';
    return mark;
  }

  /* Le gabarit du bouton « Passer » : le vraiment vierge, pas le generique.
     Quelqu'un qui passe ne veut aucune couverture imposee. */
  function skipTemplate() {
    if (!search) return null;
    var all = search.index, i;
    for (i = 0; i < all.length; i++) if (all[i].t === COPY.blankTitle) return all[i];
    for (i = 0; i < all.length; i++) if (all[i].t === COPY.fallbackTitle) return all[i];
    return null;
  }

  function coverCard(entry, opts) {
    opts = opts || {};
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cover';
    btn.setAttribute('aria-pressed', 'false');
    btn.dataset.variantId = entry.id;
    btn.dataset.handle = entry.h;
    btn.dataset.title = entry.t;

    var canvas = document.createElement('span');
    canvas.className = 'cover__canvas';

    var img = document.createElement('img');
    img.className = 'cover__img';
    img.src = sized(entry.img, 600);
    img.alt = opts.overlay ? '' : entry.t;
    img.loading = 'eager';
    canvas.appendChild(img);

    if (opts.overlay) {
      canvas.appendChild(titlePlate(opts.overlay, img, entry.t));
      btn.dataset.overlay = '1';
    }

    canvas.appendChild(checkMark());
    btn.appendChild(canvas);
    return btn;
  }

  /* La plaque recouvre le « TITLE HERE » imprime sur le gabarit blanc et
     porte le texte tape. Position en pourcentage : ca suit l'image a
     n'importe quelle taille de carte. */
  function titlePlate(text, img, templateTitle) {
    var plate = document.createElement('span');
    plate.className = 'cover__plate';
    // Chaque gabarit de repli a sa propre zone de titre imprimee : le CSS
    // positionne la plaque en fonction de ce marqueur.
    plate.dataset.plate = templateTitle === COPY.blankTitle ? 'blank' : 'classic';
    var h = document.createElement('span');
    h.className = 'cover__title';
    h.textContent = window.SVSearch.toSouvenceType(text);
    plate.appendChild(h);
    function fit() { fitTitle(h, plate); }
    if (img) img.addEventListener('load', fit);
    requestAnimationFrame(fit);
    setTimeout(fit, 250);
    return plate;
  }

  /* Le titre doit tenir dans la plaque, en 2 lignes maximum. On reduit la
     taille jusqu'a ce que ca rentre en hauteur ET en largeur. */
  function fitTitle(el, plate) {
    if (!plate || !plate.clientWidth || !plate.clientHeight) return;
    var size = plate.clientHeight * 0.62;
    var min = plate.clientHeight * 0.16;
    var guard = 0;
    el.style.fontSize = size + 'px';
    while (size > min && guard++ < 60 &&
           (el.scrollHeight > plate.clientHeight || el.scrollWidth > plate.clientWidth)) {
      size -= Math.max(0.5, size * 0.07);
      el.style.fontSize = size + 'px';
    }
  }

  /* Nombre de colonnes = nombre de cartes, plafonne a 5 sur desktop et 3 sur
     mobile. Sans ca, 4 cartes dans une grille de 5 colonnes laissent une
     colonne vide a droite et la rangee parait decalee. */
  function layoutGrid(grid) {
    if (!grid.classList.contains('is-grid')) {
      grid.style.gridTemplateColumns = '';
      return;
    }
    var max = window.matchMedia('(min-width: 700px)').matches ? 5 : 3;
    var cols = Math.min(grid.children.length, max);
    grid.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))';
  }

  window.addEventListener('resize', function () {
    var grid = $('[data-covers-grid]');
    if (grid) layoutGrid(grid);
  });

  function renderCovers(entries, opts) {
    opts = opts || {};
    var grid = $('[data-covers-grid]');
    var hint = $('[data-covers-hint]');
    grid.innerHTML = '';

    if (opts.overlayText) {
      // Aucun gabarit trouve : le gabarit blanc + le meme avec le titre tape.
      var blank = blankTemplate();
      if (blank) {
        grid.appendChild(coverCard(blank));
        grid.appendChild(coverCard(blank, { overlay: opts.overlayText }));
      }
    } else {
      var list = entries.slice(0, 24);
      list.forEach(function (e) { grid.appendChild(coverCard(e)); });

      // En voyage, le gabarit blanc titre au nom de la destination est
      // TOUJOURS propose, en derniere carte : « Marrakech », « Morocco »,
      // puis un blanc titre « MARRAKECH ». C'est l'option sobre, elle doit
      // exister quel que soit le nombre de resultats.
      // (opts.titleFor n'est renseigne que sur la branche voyage : les
      //  branches couple, 2025 et amis n'ont donc pas de carte blanche.)
      // Le gabarit generique est TOUJOURS propose en derniere carte de la
      // branche voyage, avec le nom de la destination ecrit dessus. Et si une
      // categorie ne remonte rien du tout, il sert de filet : on ne laisse
      // jamais une grille vide.
      var blank = blankTemplate();
      var dejaLa = blank && list.some(function (e) { return e.id === blank.id; });
      var categorieAvecRepli = FALLBACK_CATEGORIES[state.category] === 1;
      if (blank && !dejaLa && (opts.titleFor || categorieAvecRepli || !list.length)) {
        grid.appendChild(
          opts.titleFor ? coverCard(blank, { overlay: opts.titleFor }) : coverCard(blank)
        );
      }
    }

    $('[data-covers-title]').textContent =
      opts.overlayText ? (COPY.coversNoMatch || '') : (COPY.coversFound || '');
    if (hint) {
      hint.textContent = opts.overlayText ? (COPY.hintNoMatch || '') : '';
      hint.hidden = !opts.overlayText;
    }

    // On decide la grille APRES avoir pose toutes les cartes, carte generique
    // comprise. Avant, on comptait les gabarits et pas les cartes : avec
    // 3 gabarits + 1 generique on restait en disposition libre, sans
    // defilement, et le bouton « Passer » passait par-dessus la 4e carte.
    grid.classList.toggle('is-grid', grid.children.length > MAX_COVERS);
    layoutGrid(grid);

    var covers = $$('.cover', grid);
    covers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        press(covers, btn);
        state.template = {
          id: btn.dataset.variantId,
          h: btn.dataset.handle,
          t: btn.dataset.title,
          img: $('.cover__img', btn).src,
          overlay: btn.dataset.overlay ? state.destination : null
        };
        state.skipped = false;
        track('funnel_couverture_choisie', {
          gabarit: state.template.t,
          produit: state.template.h,
          position: covers.indexOf(btn) + 1,
          sur: covers.length
        });
        morphToEmail(btn);
      });
    });
  }

  /* ------------------------------------------------------------- ecran email */

  function fillSlot() {
    var slot = $('[data-chosen-slot]');
    var bloc = slot.closest('.covers');
    slot.innerHTML = '';
    // Apres un « Passer », on ne montre aucune couverture : rien n'a ete
    // choisi, afficher un gabarit donnerait l'impression du contraire.
    if (bloc) bloc.hidden = state.skipped === true;
    if (!state.template || state.skipped) return null;
    var canvas = document.createElement('span');
    canvas.className = 'cover__canvas';
    var img = document.createElement('img');
    img.className = 'cover__img';
    img.src = state.template.img;
    img.alt = state.template.t;
    canvas.appendChild(img);
    if (state.template.overlay) {
      canvas.appendChild(titlePlate(state.template.overlay, img, state.template.t));
    }
    canvas.appendChild(checkMark());
    slot.appendChild(canvas);
    return canvas;
  }

  function goToEmail() {
    fillSlot();
    show('email');
  }

  /* Ecran 3 → ecran 4 : la couverture choisie GLISSE jusqu'a sa place finale.
     Technique FLIP : on mesure sa position de depart, on mesure sa position
     d'arrivee, et on anime un clone entre les deux. Pendant ce temps les
     autres couvertures s'effacent et le reste de l'ecran email apparait.
     Aucune transition de page : c'est un seul mouvement continu. */
  function morphToEmail(btn) {
    var source = $('.cover__canvas', btn);
    var coversScreen = screenEl('covers');
    var emailScreen = screenEl('email');

    if (reduced || !source || !window.requestAnimationFrame) {
      setTimeout(goToEmail, reduced ? 0 : CONFIRM_MS);
      return;
    }

    var from = source.getBoundingClientRect();
    coversScreen.classList.add('is-morphing');

    // On laisse voir la coche s'allumer, puis on bascule sans animation de page.
    setTimeout(function () {
      var target = fillSlot();
      emailScreen.classList.add('is-receiving');
      show('email', true, true);

      requestAnimationFrame(function () {
        if (!target) { cleanup(); return; }
        var to = target.getBoundingClientRect();
        if (!to.width || !from.width) { cleanup(); return; }

        var ghost = source.cloneNode(true);
        ghost.classList.add('sv-ghost');
        ghost.style.left = to.left + 'px';
        ghost.style.top = to.top + 'px';
        ghost.style.width = to.width + 'px';
        ghost.style.height = to.height + 'px';
        ghost.style.transformOrigin = 'top left';
        ghost.style.transform =
          'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) ' +
          'scale(' + (from.width / to.width) + ')';
        document.body.appendChild(ghost);

        target.style.visibility = 'hidden';

        requestAnimationFrame(function () {
          ghost.style.transition = 'transform .52s ' + 'cubic-bezier(.16,.84,.44,1)';
          ghost.style.transform = 'translate(0px,0px) scale(1)';
        });

        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
          target.style.visibility = '';
          cleanup();
        };
        ghost.addEventListener('transitionend', finish);
        setTimeout(finish, 900);   // filet de securite (transition = 520 ms)
      });
    }, CONFIRM_MS);

    function cleanup() {
      coversScreen.classList.remove('is-morphing');
      emailScreen.classList.remove('is-receiving');
    }
  }

  /* ---------------------------------------------------------------- Klaviyo */

  function klaviyoKey() {
    var m = null;
    $$('script[src]', document).some(function (s) {
      var hit = s.src.match(/klaviyo\.com\/onsite\/js\/([A-Za-z0-9]+)\//) ||
                s.src.match(/[?&]company_id=([A-Za-z0-9]+)/);
      if (hit) { m = hit[1]; return true; }
      return false;
    });
    return m;
  }

  /* On n'attend JAMAIS Klaviyo : un reseau lent ne doit pas couter une
     conversion. `keepalive` laisse la requete finir apres la redirection. */
  function sendToKlaviyo(email, editorUrl) {
    var props = {
      category: state.category,
      occasion: state.occasion,
      destination_typed: state.destination || null,
      template_matched: state.template ? state.template.t : null,
      variant_id: state.template ? state.template.id : null,
      skipped: state.skipped,
      match_how: state.matchHow,
      market: root.dataset.country
    };

    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['identify', { $email: email, 'Editor URL JS': editorUrl }]);
      window.klaviyo.push(['track', 'Started Album Funnel', props]);
    } catch (e) { console.warn('[sv-funnel] klaviyo onsite KO', e); }

    var key = klaviyoKey();
    var list = root.dataset.klaviyoList;
    if (!key || !list) { console.warn('[sv-funnel] cle ou liste Klaviyo absente'); return; }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST', keepalive: true, mode: 'cors',
      headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      })
    }).catch(function (e) { console.warn('[sv-funnel] abonnement Klaviyo KO', e); });
  }

  /* Journal des recherches vides (§8) : le vrai signal commercial. */
  function logEmptySearch(term) {
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'Album Search Empty', {
        term: term, category: state.category, market: root.dataset.country
      }]);
    } catch (e) {}
  }

  /* ------------------------------------------------------------- navigation */

  function afterCategory(btn) {
    state.category = btn.dataset.choice;
    state.occasion = null;
    state.destination = '';
    state.matchHow = null;

    track('funnel_categorie', {
      suite: btn.dataset.needsOccasion === '1' ? 'occasion'
           : btn.dataset.needsSearch === '1'   ? 'recherche' : 'couvertures'
    });

    if (btn.dataset.needsOccasion === '1') { show('occasion'); return; }
    if (btn.dataset.needsSearch === '1')   { show('destination'); return; }
    ready.then(function () {
      if (!search) return;
      var pool = search.pool(state.category, state.occasion);
      renderCovers(pool);
      track('funnel_couvertures', { nb: pool.length, venant_de: 'direct' });
      show('covers');
    });
  }

  var choices = $$('[data-choice]');
  choices.forEach(function (btn) {
    btn.addEventListener('click', function () {
      press(choices, btn);
      setTimeout(function () { afterCategory(btn); }, reduced ? 0 : 160);
    });
  });

  var occasions = $$('[data-occasion]');
  occasions.forEach(function (btn) {
    btn.addEventListener('click', function () {
      press(occasions, btn);
      state.occasion = btn.dataset.occasion;
      track('funnel_occasion', {});
      ready.then(function () {
        if (!search) return;
        var pool = search.pool(state.category, state.occasion);
        renderCovers(pool);
        track('funnel_couvertures', { nb: pool.length, venant_de: 'occasion' });
        show('covers');
      });
    });
  });

  /* ------------------------------------------------- suggestions en direct */

  var destForm = $('[data-form="destination"]');
  var suggestBox = $('[data-suggest]');
  var suggestions = [];
  var cursor = -1;
  var debounce = null;

  function hideSuggest() {
    suggestions = [];
    cursor = -1;
    if (suggestBox) { suggestBox.hidden = true; suggestBox.innerHTML = ''; }
  }

  /* Met en gras la partie deja tapee, pour qu'on voie pourquoi ca matche. */
  function highlight(label, typed) {
    var norm = window.SVSearch.normalize(label);
    var q = window.SVSearch.normalize(typed);
    var frag = document.createDocumentFragment();
    if (q && norm.indexOf(q) === 0) {
      var strong = document.createElement('strong');
      strong.textContent = label.slice(0, q.length);
      frag.appendChild(strong);
      frag.appendChild(document.createTextNode(label.slice(q.length)));
    } else {
      frag.appendChild(document.createTextNode(label));
    }
    return frag;
  }

  function renderSuggest(list, typed) {
    if (!suggestBox) return;
    suggestions = list;
    cursor = -1;
    suggestBox.innerHTML = '';
    if (!list.length) { suggestBox.hidden = true; return; }

    list.forEach(function (s, i) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sv-suggest__item';
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', 'false');
      btn.dataset.i = i;

      var thumb = document.createElement('img');
      thumb.className = 'sv-suggest__thumb';
      thumb.src = sized(s.entry.img, 96);
      thumb.alt = '';
      thumb.loading = 'lazy';
      btn.appendChild(thumb);

      var label = document.createElement('span');
      label.className = 'sv-suggest__label';
      label.appendChild(highlight(s.label, typed));
      btn.appendChild(label);

      btn.addEventListener('mousedown', function (e) { e.preventDefault(); });
      btn.addEventListener('click', function () { pickSuggestion(i); });
      li.appendChild(btn);
      suggestBox.appendChild(li);
    });
    suggestBox.hidden = false;
  }

  function moveCursor(delta) {
    if (!suggestions.length) return;
    var n = suggestions.length;
    cursor += delta;
    if (cursor < 0) cursor = n - 1;
    if (cursor >= n) cursor = 0;
    $$('.sv-suggest__item', suggestBox).forEach(function (b, i) {
      b.setAttribute('aria-selected', String(i === cursor));
    });
  }

  function pickSuggestion(i) {
    var s = suggestions[i];
    if (!s) return;
    var input = destForm.querySelector('input');
    input.value = s.label;
    state.destination = s.label;
    state.matchHow = s.how;
    hideSuggest();
    var pool = search.pool(state.category, state.occasion);
    renderCovers(search.withCountrySiblings(pool, search.byTitles(pool, [s.entry.t])),
                 { titleFor: s.label });
    show('covers');
  }

  if (destForm) {
    var destInput = destForm.querySelector('input');

    destInput.addEventListener('input', function () {
      clearTimeout(debounce);
      var value = destInput.value;
      debounce = setTimeout(function () {
        ready.then(function () {
          if (!search) return;
          renderSuggest(search.suggest(value, state.category, state.occasion, 5), value);
        });
      }, 110);
    });

    destInput.addEventListener('keydown', function (e) {
      if (suggestBox && suggestBox.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); moveCursor(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); moveCursor(-1); }
      else if (e.key === 'Escape') { hideSuggest(); }
      else if (e.key === 'Enter' && cursor >= 0) { e.preventDefault(); pickSuggestion(cursor); }
    });

    destInput.addEventListener('blur', function () { setTimeout(hideSuggest, 120); });

    destForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var value = destInput.value.trim();
      if (!value) { setError(destForm, COPY.errDestination); destInput.focus(); return; }
      setError(destForm, '');
      hideSuggest();
      state.destination = value;

      ready.then(function () {
        if (!search) return;
        var res = search.resolve(value, state.category, state.occasion);
        state.matchHow = res.how;
        track('funnel_recherche', {
          terme: value,
          trouve: res.matches.length > 0,
          comment: res.how || null,
          nb: res.matches.length
        });
        if (res.matches.length) {
          // On titre le gabarit blanc avec le nom du CATALOGUE, pas avec la
          // saisie : « japon » tape doit donner « JAPAN » ecrit sur la couverture.
          renderCovers(res.matches, {
            titleFor: res.matches[0].t.replace(/\s+\d+$/, '')
          });
        } else {
          logEmptySearch(window.SVSearch.normalize(value));
          renderCovers([], { overlayText: value });
        }
        track('funnel_couvertures', {
          nb: $$('.cover', $('[data-covers-grid]')).length,
          venant_de: res.matches.length ? 'recherche' : 'recherche_vide'
        });
        show('covers');
      });
    });
  }

  var skipBtn = $('[data-skip]');
  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      ready.then(function () {
        var vierge = skipTemplate();
        if (!vierge) return;
        state.skipped = true;
        state.template = { id: vierge.id, h: vierge.h, t: vierge.t,
                           img: sized(vierge.img, 600), overlay: null };
        track('funnel_passer', { gabarit: vierge.t });
        goToEmail();
      });
    });
  }

  var mailForm = $('[data-form="email"]');
  if (mailForm) {
    mailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = mailForm.querySelector('input');
      var submit = mailForm.querySelector('.field__submit');
      var value = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
        setError(mailForm, COPY.errEmail); input.focus(); return;
      }
      setError(mailForm, '');
      if (!state.template) return;

      submit.classList.add('is-busy');
      var url = '/products/' + state.template.h +
                '?variant=' + encodeURIComponent(state.template.id) +
                '&' + root.dataset.openParam + '=1';

      track('funnel_email', {
        gabarit: state.template.t,
        produit: state.template.h,
        passe: state.skipped === true
      });
      try {
        if (typeof window.scIdentify === 'function') window.scIdentify(value);
      } catch (e) {}
      sendToKlaviyo(value, window.location.origin + url);
      window.location.href = url;   // on part sans attendre Klaviyo
    });
  }

  var back = $('[data-sv-back]');
  if (back) back.addEventListener('click', goBack);

  /* Premier evenement du parcours. Emis apres un tour de boucle, le temps que
     sc-track.liquid ait pose window.scTrack. */
  setTimeout(function () { track('funnel_vue', {}); }, 0);
})();
